import type { Company } from '@dcc-erp/shared';

import { AppHeader } from './AppHeader';
import { Sidebar } from './Sidebar';

import type { ReactNode } from 'react';

export interface AppShellProps {
  company: Company;
  active: string;
  onSelect: (id: string) => void;
  onLogout: () => void;
  children: ReactNode;
}

export function AppShell({ company, active, onSelect, onLogout, children }: AppShellProps) {
  return (
    <div className="app">
      <AppHeader company={company} page={active} onLogout={onLogout} />
      <Sidebar active={active} onSelect={onSelect} />
      <main className="app-main">{children}</main>
    </div>
  );
}
